import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProductIdentifierComponent } from '@boels/elements';
import { BOProduct } from '@boels/models';
import { Observable } from 'rxjs';

@Component({
  selector: 'boels-product-intro',
  templateUrl: './product-intro.component.html',
  styleUrls: ['./product-intro.component.scss'],
  imports: [AsyncPipe, ProductIdentifierComponent],
})
export class ProductIntroComponent {
  @Input()
  componentData: { product$: Observable<BOProduct> };
}
